import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class DailyAnalyticSessionLogsService extends RestfulService<Models.DailyAnalyticSessionLogByTimestamp> {

  constructor(public restService: RestService) {
    super(Models.DailyAnalyticSessionLogByTimestamp);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('daily-analytic-session-log-by-timestamps');
  }
}
